import {Grid, Typography} from '@logistics-frontend/blocks'
import {CopyAltIcon} from '@logistics-frontend/blocks/icons'
import clsx from 'clsx'
import React from 'react'

import {classes} from '../PromoBannerButton.classes'
import {Props} from './CopyButton.types'

// TODO кажется это должен быть обычный Button + Lead + Text
const Base: React.FC<Props> = ({onClick, text}) => (
  <button className={clsx(classes.button, classes.copyButton)} onClick={onClick} type="button">
    <Grid alignItems="center" justify="center" wrap="nowrap" container zeroMinWidth>
      <Grid alignItems="center" item>
        <CopyAltIcon className={classes.copyIcon} />
      </Grid>
      <Grid alignItems="center" item>
        <Typography thickness="medium" variant="caption1">
          {text}
        </Typography>
      </Grid>
    </Grid>
  </button>
)
export const CopyButton = React.memo(Base)
